import { Link } from "react-router-dom";
import ContactCta from "../../Components/ContactCta";
import { FaGasPump, FaCheckCircle, FaTachometerAlt } from "react-icons/fa";
import { MACHINERY, PARTS, SERVICES } from "../../constants";
import { PREV_IMG } from "../../constants/endPoints";
import { convertNumber, convertToBase64, currencyFormat, hasPrice, hasYear, machineTypeLabel, optText } from "../../constants/helper";

const ProductListItem = ({ val, i, loc, ...props }) => {
    const manuName = optText(val.manufacturer_id == -1 ? val.manufacturer_name : (val.manufacturer && val.manufacturer.name));
    const modelName = optText(val.model_id == -1 ? val.model_name : (val.model && val.model.name));
    const year = hasYear(val.year) ? val.year : '';
    const isParts = val.category_id == PARTS;
    const isMachinery = val.category_id == MACHINERY;
    const machineType = isMachinery ? machineTypeLabel(val.item_type) : '';
    const ownTitle = isParts && val.title;
    const vehicleCategory = optText(val.vehicle_category && val.vehicle_category.category_name);
    const vehicleBrand = optText(val.vehicle_brand && val.vehicle_brand.name);
    const conditionName = optText(val.condition_of_item && val.condition_of_item.name);
    const colorValue = optText(val.color && val.color.color_value);
    const vehicleTitle = [manuName, modelName, year].filter(Boolean).join(' ');
    return (
        <div className="sectls" key={i}>
            <Link to={"/product_details/" + convertToBase64(val.id)} className="sectls-img">
                <img src={PREV_IMG + val.default_photo.img_path} alt={(manuName && !ownTitle)
                    ? vehicleTitle
                    : val.title} onError={(e) => { e.target.src = "/assets/images/placeholder.jpeg" }} />
            </Link>
            <div className="sectls-cont">
                <div className="sectls-ttl-wrap">
                    {/* Check if there is menufecturer then show manufacturer as title else show title */}

                    {
                        manuName && !ownTitle &&
                        <h3>
                            <Link to={"/product_details/" + convertToBase64(val.id)}>
                                {vehicleTitle}
                                &nbsp;
                                {/* {val.sell_type == "Rent" ? "Para alugar" : "Para venda"} */}

                            </Link>
                        </h3>
                    }
                    {
                        (!manuName || ownTitle) &&
                        <h3><Link to={"/product_details/" + convertToBase64(val.id)}>{val.title}
                            &nbsp;({val.sell_type == "Rent" ? "Para alugar" : "Para venda"})</Link></h3>
                    }

                </div>
                {hasPrice(val.price) ? <div className="sectls-price-wrap">
                    <p>Preço</p>
                    <p className="sectls-price">{currencyFormat(val.price)} {val.item_currency && val.item_currency.currency_symbol}</p>
                </div> : <div className="sectls-price-wrap"><ContactCta item={val} compact /></div>}
                {
                    isParts && vehicleCategory &&
                    <div className="sectls-qnt-wrap">
                        <p>Tipo de veículo</p>
                        <p className="sectls-price mt-2">{vehicleCategory}</p>
                    </div>
                }
                {
                    isParts && vehicleBrand &&
                    <div className="sectls-qnt-wrap">
                        <p>Marca do veículo</p>
                        <p className="sectls-price mt-2">{vehicleBrand}</p>
                    </div>
                }
                {
                    isParts && manuName &&
                    <div className="sectls-qnt-wrap">
                        <p>Categoria</p>
                        <p className="sectls-price mt-2">{manuName}</p>
                    </div>
                }
                {
                    isParts && modelName &&
                    <div className="sectls-qnt-wrap">
                        <p>Sub Categoria</p>
                        <p className="sectls-price mt-2">{modelName}</p>
                    </div>
                }
                {
                    machineType &&
                    <div className="sectls-qnt-wrap">
                        <p>Tipo</p>
                        <p className="sectls-price mt-2">{machineType}</p>
                    </div>
                }
                {
                    val.fuel_type.fuel_name &&
                    <div className="sectls-qnt-wrap">
                        <p>Tipo de combustível</p>
                        <p className="sectls-price mt-2"><FaGasPump className="ic-rm4" />{val.fuel_type.fuel_name}</p>

                    </div>
                }
                {
                    (!val.fuel_type.fuel_name || isMachinery) && val.category_id != SERVICES && conditionName &&
                    <div className="sectls-qnt-wrap">
                        <p>Estado</p>
                        <p className="sectls-price mt-2"><FaCheckCircle className="ic-rm4" />{conditionName}</p>

                    </div>
                }
                {
                    val.mileage && convertNumber(val.mileage) > 0 &&
                    <div className="sectls-total-wrap">
                        <p>Quilômetros</p>
                        <p className="sectls-total mt-2"><FaTachometerAlt className="ic-rm4" />{currencyFormat(val.mileage)} Km</p>
                    </div>
                }
            </div>
            <div className="sectls-info">

                <div className="sectls-rating-wrap">
                    <p className="sectls-rating">
                        Carregado
                    </p>
                    <p className="uploaded_txt">{val.added_date_str}</p>
                </div>
                { loc && loc.name && <div className="sectls-rating-wrap">
                    <p className="sectls-rating">
                        Província
                    </p>
                    <p className="uploaded_txt">{loc.name}</p>
                </div>}
                {
                    val.sell_type == "Rent" &&
                    <div className="sectls-rating-wrap">
                        <p className="sectls-rating">
                            Tipo
                        </p>
                        <p className="uploaded_txt">Aluguer</p>
                    </div>
                }
                {
                    colorValue &&
                    <p className="sectls-id">Cor <span className="badge bg-primary bg-sn badge_pos"> {colorValue}</span></p>
                }


            </div>
        </div>
    );
}

export default ProductListItem;
